import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import CloneConfig from './submodules/clone';
import CreateConfig from './submodules/create';
import ConfigList from './submodules/list';
import EditConfig from './submodules/edit';

const TdsConfigDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.finance}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].getTDSConfigs]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ConfigList}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.finance}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].createTDSConfigs]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/clone`}
				component={CloneConfig}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.finance}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].createTDSConfigs]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateConfig}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.finance}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].updateTDSConfigs]}
				path={`${path}/edit`}
				configPageName={PAGE_NAMES.dashboard}
				component={EditConfig}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default TdsConfigDashboard;
